import quickFetch from 'quick-fetch';
(function () {
  quickFetch.afterAuth(authData => {
    var _authData$user;
    const scopes = (authData === null || authData === void 0 || (_authData$user = authData.user) === null || _authData$user === void 0 ? void 0 : _authData$user.scopes) || [];
    // Only make initial requests if the user has the chatspot-access scope
    if (scopes.includes('chatspot-access')) {
      quickFetch.makeEarlyRequest('chatspotAuth', {
        url: quickFetch.getApiUrl('/chatspot-high-volume/v1/user/info'),
        dataType: 'json',
        contentType: 'application/json',
        type: 'GET',
        data: JSON.stringify({
          early: true
        })
      });
    }
  });
})();